<div 
  class="result-box" 
  tabindex="0" 
  role="button" 
  (keydown.enter)="onClickCard(match_item.onet_code!)"
  (keydown.space)="$event.preventDefault(); onClickCard(match_item.onet_code!)"
>
  <div class="card-click-overlay" (click)="onClickCard(match_item.onet_code!)"></div>
  <!-- <img
    [src]="'/assets/icons/results/' + (match_item.saved ? 'bookmark-saved.svg' : 'bookmark.svg')"
    alt="bookmark"
    class="bookmark-icon"
    (click)="onClickBookmark()" 
  /> -->
  <div class="match-image-div">
    <div class="match-image">
      <img 
        [src]="'/assets/icons/results/career/' + match_item.icon" 
        alt="career-card" 
      />
    </div>
  </div>
  <div class="match-details">
    <div class="career-title-div">
      <h2 class="career-title truncate-title">{{ match_item.title }}</h2>
      <img 
        [src]="'/assets/icons/results/match-scores/' + match_item.match_score + '.svg'" 
        alt="h1-plus" 
      />
    </div>
    <div class="career-desc-div">
      <img src="/assets/icons/results/dollar.svg" alt="h1-plus" />
      <p class="career-desc">
        Median Salary <span>{{ match_item.salary }}</span>
      </p>
    </div>
    <div class="career-desc-div">
      <img src="/assets/icons/results/growth.svg" alt="growth" />
      <p class="career-desc">
        Growth <span>{{ match_item.growth }}</span>
      </p>
    </div>
  </div>
</div>